export const LS_ORDERS = 'gorders_'
